//THIS IS ONLY USED DURING HR BETA TEST.
import { Box, Typography } from '@mui/material'
import OnboardingContainer from 'components/smart/onboarding-container/OnboardingContainer'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Astronaut from '../assets/astronaut.svg'
import AdxButton from 'components/custom/AdxButton'

const SignUpTokenFail = () => {
  const location = useLocation()
  const navigate = useNavigate()

  // redirect if the user not from signup page
  useEffect(() => {
    if (!location?.state?.error) {
      navigate('/signup')
    }
  }, [location?.state?.error, navigate])

  return (
    <OnboardingContainer
      bgColorRight="alternate.main"
      topRightPhoto="10%"
      leftRightPhoto="75%"
      heightRightPhoto="100%"
      transformRightPhoto={`translate(${-50}%, ${0}%)`}
    >
      <Box
        component="img"
        src={Astronaut}
        position="fixed"
        bottom={0}
        right={0}
        width="calc(100vw * 0.55)"
        display={{ xs: 'none', lg: 'block' }}
      />
      <Box
        height={'100%'}
        width={'100%'}
        display="flex"
        justifyContent={{ xs: 'center', lg: 'center' }}
        alignItems={{ xs: 'center', lg: 'center' }}
      >
        <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography variant="h2" mb={2} fontWeight="bold">
            Error
          </Typography>
          <Typography
            variant="body1"
            mb={4}
            style={{ maxWidth: '300px' }}
            color={'#8A8A8A'}
            textAlign="center"
          >
            {location?.state?.error?.error === 'jwt expired'
              ? 'Your token has expired. Contact our admin to generate a new link.'
              : 'Your token is invalid. Contact our admin to generate a new link.'}
          </Typography>
          <AdxButton
            variant={'contained'}
            onClick={() => navigate('/')}
            style={{ width: '50%' }}
            size="small"
          >
            Home
          </AdxButton>
        </Box>
      </Box>
    </OnboardingContainer>
  )
}

export default SignUpTokenFail
